import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import Skeleton from '../../componentsv2/Skeleton';
import Layout from '../../componentsv2/Layout';

export default function CompliancePageSkeleton() {
  return (
    <Layout>
      <Grid container rowSpacing={2}>
        {/* Header Section */}
        <Grid item xs={12}>
          <Grid container rowSpacing={1}>
            <Grid item xs={12}>
              <Skeleton variant="rectangular" width="25%" height="36px" animation="wave" />
            </Grid>
            <Grid item xs={12}>
              <Skeleton variant="rectangular" width="60%" height="21px" animation="wave" />
            </Grid>
          </Grid>
        </Grid>

        {/* Main Content Grid */}
        <Grid item xs={12}>
          <Grid container spacing={3}>
            {/* Contact Account Manager Card (Top Left) */}
            <Grid item xs={12} lg={5}>
              <Box
                sx={{
                  backgroundColor: '#2D4B79',
                  borderRadius: '12px',
                  padding: '20px 24px',
                  minHeight: '200px',
                  display: 'flex',
                  flexDirection: 'column',
                  gap: '28px',
                }}
              >
                <Box sx={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
                  <Box sx={{ display: 'flex', gap: '9px', alignItems: 'center' }}>
                    <Skeleton variant="circular" width="20px" height="20px" animation="wave" />
                    <Skeleton variant="rectangular" width="40%" height="16px" animation="wave" />
                  </Box>
                  <Skeleton variant="rectangular" width="60%" height="24px" animation="wave" />
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                    <Skeleton variant="rectangular" width="50%" height="16px" animation="wave" />
                    <Skeleton variant="circular" width="16px" height="16px" animation="wave" />
                  </Box>
                </Box>
                <Box>
                  <Skeleton variant="rectangular" width="100%" height="40px" animation="wave" />
                </Box>
              </Box>
            </Grid>

            {/* Plan Information Card (Top Right) */}
            <Grid item xs={12} lg={7}>
              <Box
                sx={{
                  backgroundColor: '#fff',
                  borderRadius: '12px',
                  minHeight: '200px',
                  display: 'flex',
                  flexDirection: 'column',
                }}
              >
                {/* Header */}
                <Box
                  sx={{
                    padding: '20px 28px',
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                  }}
                >
                  <Box sx={{ display: 'flex', gap: '11px', alignItems: 'center' }}>
                    <Skeleton variant="rectangular" width="30%" height="18px" animation="wave" />
                    <Skeleton
                      variant="rectangular"
                      width="80px"
                      height="24px"
                      animation="wave"
                      sx={{ borderRadius: '12px' }}
                    />
                  </Box>
                  <Skeleton variant="rectangular" width="20%" height="16px" animation="wave" />
                </Box>

                {/* Divider */}
                <Box sx={{ height: '1px', backgroundColor: '#DEE9FA', margin: '0 28px' }} />

                {/* Content */}
                <Box sx={{ padding: '20px 28px', display: 'flex', flexDirection: 'column', gap: '20px' }}>
                  <Box sx={{ display: 'flex', gap: '12px', alignItems: 'center' }}>
                    <Skeleton variant="circular" width="20px" height="20px" animation="wave" />
                    <Box sx={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
                      <Skeleton variant="rectangular" width="30%" height="16px" animation="wave" />
                      <Skeleton variant="rectangular" width="50%" height="16px" animation="wave" />
                    </Box>
                  </Box>
                  <Box sx={{ display: 'flex', gap: '12px', alignItems: 'center' }}>
                    <Skeleton variant="circular" width="20px" height="20px" animation="wave" />
                    <Box sx={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
                      <Skeleton variant="rectangular" width="25%" height="16px" animation="wave" />
                      <Skeleton variant="rectangular" width="40%" height="16px" animation="wave" />
                    </Box>
                  </Box>
                  <Box sx={{ display: 'flex', gap: '12px', alignItems: 'center' }}>
                    <Skeleton variant="circular" width="20px" height="20px" animation="wave" />
                    <Box sx={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
                      <Skeleton variant="rectangular" width="20%" height="16px" animation="wave" />
                      <Skeleton variant="rectangular" width="35%" height="16px" animation="wave" />
                    </Box>
                  </Box>
                </Box>
              </Box>
            </Grid>

            {/* Latest Documents Card (Bottom Left) */}
            <Grid item xs={12} md={6} lg={7}>
              <Box
                sx={{
                  backgroundColor: '#fff',
                  borderRadius: '12px',
                  minHeight: '200px',
                  display: 'flex',
                  flexDirection: 'column',
                }}
              >
                {/* Header */}
                <Box
                  sx={{
                    padding: '20px 28px',
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                  }}
                >
                  <Skeleton variant="rectangular" width="30%" height="18px" animation="wave" />
                  <Skeleton variant="rectangular" width="15%" height="16px" animation="wave" />
                </Box>

                {/* Divider */}
                <Box sx={{ height: '1px', backgroundColor: '#DEE9FA', margin: '0 28px' }} />

                {/* Content */}
                <Box
                  sx={{
                    padding: '20px 28px',
                    display: 'flex',
                    flexDirection: 'column',
                    gap: '12px',
                    alignItems: 'center',
                    justifyContent: 'center',
                    flex: 1,
                  }}
                >
                  <Skeleton variant="rectangular" width="60%" height="24px" animation="wave" />
                  <Skeleton variant="rectangular" width="80%" height="16px" animation="wave" />
                </Box>
              </Box>
            </Grid>

            {/* Product Cards (Bottom Right) */}
            <Grid item xs={12} md={6} lg={5}>
              <Box sx={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
                {/* Accounting Card */}
                <Box
                  sx={{
                    backgroundColor: '#E8F0FC',
                    borderRadius: '12px',
                    padding: '24px 32px',
                    minHeight: '120px',
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    gap: '28px',
                  }}
                >
                  <Box sx={{ display: 'flex', flexDirection: 'column', gap: '4px', flex: 1 }}>
                    <Box sx={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
                      <Skeleton variant="circular" width="20px" height="20px" animation="wave" />
                      <Skeleton variant="rectangular" width="40%" height="18px" animation="wave" />
                    </Box>
                    <Skeleton variant="rectangular" width="80%" height="16px" animation="wave" />
                  </Box>
                  <Box>
                    <Skeleton variant="rectangular" width="100px" height="40px" animation="wave" />
                  </Box>
                </Box>
              </Box>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Layout>
  );
}
